import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC, useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import { RootState, useDispatch, useSelector } from 'src/store';
import { modalImagePage, pagesReset } from 'src/store/modules/pages';
import modalSlickAlt from 'src/images/modalSlickAlt.png';
import CloseIcon from '@material-ui/icons/Close';

import { editTextReset } from 'src/store/modules/editText';
import {
  buttonsReset,
  editBtnBgColor,
  editBtnColor,
  editBtnFontFamily,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnPreFontSize,
  editBtnRadius,
  editBtnText,
  editBtnTextAlign
} from 'src/store/modules/buttons';
import {
  imageReset,
  //
  editBg,
  editBgColor,
  editBgImage,
  editBgImageBlur,
  editRadius,
  editCurrentIndex,
  editDeeplink
} from 'src/store/modules/imageUpload';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import setInitValue from 'src/utils/setInitValue';
import { changeText } from 'src/utils/changeText';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/AutoSquareSlideTracking';
import { editUserCompany } from 'src/store/modules/client';
import { customlogReset } from 'src/store/modules/customlog';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';

const initViewValues = {
  currentIndex: 0,
  bg: 'color',
  bgImage: {
    background: '',
    multi_image: [
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp'
    ]
  },
  bgColor: {
    background: '#000000'
  },
  radius: { background: 16, multi_image: 14 },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },

  text: {
    multi_title: ['SALE UP TO 30%', 'SALE UP TO 40%', 'SALE UP TO 50%'],
    multi_sub_title: [
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members. Get a designer brand products at a sale price. Give away a 10$ coupon for members.',
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members.',
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members.'
    ]
  },
  fontSize: { multi_title: 1.25, multi_sub_title: 0.75 },
  fontWeight: { multi_title: 700, multi_sub_title: 400 },
  color: { multi_title: '#ffffff', multi_sub_title: '#ffffff' },
  fontFamily: { multi_title: 'Inter', multi_sub_title: 'Inter' },
  textAlign: { multi_title: 'center', multi_sub_title: 'center' },

  btnText: {
    multi_left_button: [
      "Don't show again",
      "Don't show again",
      "Don't show again"
    ],
    multi_right_button: ['Close', 'Close', 'Close']
  },
  btnBgColorR: { multi_left_button: 0, multi_right_button: 0 },
  btnBgColorG: { multi_left_button: 0, multi_right_button: 0 },
  btnBgColorB: { multi_left_button: 0, multi_right_button: 0 },
  btnBgColorA: { multi_left_button: 0, multi_right_button: 0 },
  btnFontSize: { multi_left_button: 0.875, multi_right_button: 0.875 },
  btnFontWeight: { multi_left_button: 400, multi_right_button: 400 },
  btnColor: { multi_left_button: '#ffffff', multi_right_button: '#ffffff' },
  btnFontFamily: {
    multi_left_button: 'Inter',
    multi_right_button: 'Inter'
  },
  btnAgain: {
    type: 'none',
    multi_left_button: "don't show"
  },
  button1: {
    multi_image: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    multi_left_button: [],
    multi_right_button: []
  },
  button2: {
    multi_image: [],
    multi_left_button: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    multi_right_button: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
  }
};

const AutoSquareSlide: FC = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const [currentUser, setCurrentUser] = useState('');

  let clientName = useSelector((state: RootState) => state.client.userCompany);
  let templateWidth = useSelector((state: any) => state.template.templateWidth);
  let templateHeight = useSelector(
    (state: any) => state.template.templateHeight
  );
  let currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  let bg = useSelector((state: RootState) => state.imageUpload.bg);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let switchState = useSelector(
    (state: RootState) => state.switchButton.switchState
  );
  let switchSpeed = useSelector(
    (state: RootState) => state.switchButton.switchSpeed
  );

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        setCurrentUser(current.attributes['custom:Company']);
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiLeftButtonFontURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonFontURL = getFontURL(btnFontFamily?.multi_right_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiSubTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_sub_title}`;
  // const multiLeftButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_left_button}`;
  // const multiRightButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_right_button}`;
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );

          if (
            customValues?.bgImage &&
            customValues?.text &&
            customValues?.btnText
          ) {
            setInitValue(dispatch, customValues);
          } else {
            setValue(
              dispatch,
              customValues,
              { ...initViewValues, ...initTrackingValues },
              clientName
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);

  // const modalLeftUrl = 'https://i.ibb.co/xL684x8/modal-left.png';
  // const modalRightUrl = 'https://i.ibb.co/89XNkSx/modal-right.png';
  // const closeImageUrl = 'https://i.ibb.co/xC9Gcwb/Frame-6.png';

  const style = `
  @Font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @Font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @Font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonFontURL});
  }
  @Font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonFontURL});
  }
  .root_view {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
    
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.5);
    }
    
    .modal_wrapper {
      width: 100%;
      padding: 18px;

      display: flex;
      flex-direction: column;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      border-radius: ${radius?.background}px;
      
    }
    
    .slick_page {
      padding: 0.19rem 0.5rem;
      position: absolute;
      
      right: 6px;
      bottom: 6px;
      display:flex;
      gap: 0.2rem;
    
      color: #fff;
      font-family: Roboto;
      font-size: 0.7rem;
      font-weight: 400;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;      
    }
    .slick_wrapper {
      position: relative;
    }
    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      aspect-ratio: 1;
      outline: none;
    }
    .slick_wrapper .slick-list {
      overflow: hidden;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px ${
    radius?.multi_image
  }px ${radius?.multi_image}px;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
    }
    .btn_wrapper {
      margin-top: 11px;
      padding: 0rem 0rem;

      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .btn_wrapper button {
      border: 0;
      background-color: transparent;
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Arial'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily?.multi_left_button
          : 'multiLeftButton'
      };
      padding-left: 0.5rem;
      text-align: left;
      background-color:rgba(${btnBgColorR?.multi_left_button},${
    btnBgColorG?.multi_left_button
  }, ${btnBgColorB?.multi_left_button}, ${btnBgColorA?.multi_left_button});
    }
    .btn_wrapper .style02 {
      display:flex;
      justify-content: flex-end;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Arial'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily?.multi_right_button
          : 'multiRightButton'
      };

      text-align: right;
      background-color:rgba(${btnBgColorR?.multi_right_button},${
    btnBgColorG?.multi_right_button
  }, ${btnBgColorB?.multi_right_button}, ${btnBgColorA?.multi_right_button});
    }
    
    ${
      templateWidth > 767
        ? `
          .modal_wrapper {
            width: 50%;
            margin: 0 25%;
          }

          .close_btn {
            right: 25%;
            top: 4rem;
          }

          .contents_wrapper {
            padding: 0 2rem;
            margin: 3rem 0 2rem 0;
          }
          .contents_box .title {
            font-size: ${fontSize?.multi_title + 0.25}rem;
          }
          .slick_page {
            bottom: 5rem;
          }

          .btn_wrapper {
            height: 4rem;
            padding: 0.5rem 2rem;
            font
          }
          .btn_wrapper .style01 {
            font-size: ${btnFontSize?.multi_left_button + 0.25}rem;
          }
          .btn_wrapper .style02 {
            font-size: ${btnFontSize?.multi_right_button + 0.25}rem;
          }
        `
        : ``
    }
  }
  `;
  const [autoSpeed, setAutoSpeed] = useState(2000);

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex]);

  useEffect(() => {
    if (sliderRef.current) {
      setAutoSpeed(switchSpeed * 1000);
      sliderRef.current.slickPlay();
    }
  }, [switchSpeed, switchState]);

  const settings = {
    arrows: false,
    infinite: true,
    dots: false,
    speed: 300,
    touchThreshold: 300,
    swipeToSlide: true,
    autoplay: switchState
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="background"></div>
        <div className="modal_wrapper">
          <div className="slick_wrapper">
            <Slider
              {...settings}
              ref={sliderRef}
              autoplaySpeed={autoSpeed}
              afterChange={index => {
                dispatch(editCurrentIndex(index));
              }}
            >
              {bgImage?.multi_image?.map((data: any, idx: number) => {
                return (
                  <div key={idx}>
                    <img
                      src={data && data !== '' ? data : modalSlickAlt}
                      alt=""
                    />
                  </div>
                );
              })}
            </Slider>
            {bgImage?.multi_image?.length !== 1 && (
              <div className="slick_page">
                <span>{currentIndex + 1}</span>
                <span className="slash" style={{ color: '#828282' }}>
                  /
                </span>
                <span style={{ color: '#828282' }}>
                  {bgImage?.multi_image?.length}
                </span>
              </div>
            )}
          </div>
          <div className="btn_wrapper">
            <button className="style01">
              {btnText?.multi_left_button?.[currentIndex]}
            </button>
            <button className="style02">
              {btnText?.multi_right_button?.[currentIndex]}
              <CloseIcon
                style={{
                  fontSize: `${btnFontSize?.multi_right_button + 0.25}rem`,
                  color: `${btnColor?.multi_right_button}`
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const setValue = (
  dispatch: any,
  values: any,
  initViewValuess: any,
  clientName: any
) => {
  // console.log(values);
  // console.log('test');
  // dispatch(editBgColor(values?.bgColor));
  const MultiBackground = values?.imageName?.map((data: any) => {
    return `https://image.inappmessage.com/${clientName}/${data}`;
  });
  dispatch(
    editBgImage({
      multi_image: MultiBackground
    })
  );
  //  dispatch(editBgImageBlur(values?.bgImageBlur));
  dispatch(editDeeplink({ multi_image: values?.newDeepLink }));
  dispatch(
    editRadius({
      ...initViewValuess?.radius,
      ...{ background: values?.newImgRadius }
    })
  );

  // dispatch(editText(values?.text));
  // dispatch(editPreFontSize(values?.fontSize));
  // dispatch(editFontSize(values?.fontSize));
  // dispatch(editFontWeight(values?.fontWeight));
  // dispatch(editColor(values?.color));
  // dispatch(editFontFamily(values?.fontFamily));
  // dispatch(editTextAlign(values?.textAlign));

  dispatch(
    editBtnText({
      multi_left_button: [
        changeText(values?.newBtnText),
        changeText(values?.newBtnText),
        changeText(values?.newBtnText)
      ],
      multi_right_button: [
        changeText(values?.newCloseText),
        changeText(values?.newCloseText),
        changeText(values?.newCloseText)
      ]
    })
  );
  dispatch(
    editBtnPreFontSize({
      multi_left_button: values?.newBtnFontSize / 16,
      multi_right_button: values?.newCloseFontSize / 16
    })
  );
  dispatch(
    editBtnFontSize({
      multi_left_button: values?.newBtnFontSize / 16,
      multi_right_button: values?.newCloseFontSize / 16
    })
  );
  dispatch(
    editBtnFontWeight({
      multi_left_button: values?.newBtnFontWeight,
      multi_right_button: values?.newCloseFontWeight
    })
  );
  dispatch(
    editBtnColor({
      multi_left_button: values?.newBtnTextColor,
      multi_right_button: values?.newCloseTextColor
    })
  );
  //     dispatch(
  //       editBtnBgColor(
  //         values?.btnBgColorR,
  //         values?.btnBgColorG,
  //         values?.btnBgColorB,
  //         values?.btnBgColorA
  //       )
  //     );
  //     dispatch(editBtnFontFamily(values?.btnFontFamily));
  //     dispatch(editBtnTextAlign(values?.btnTextAlign));
};

export default AutoSquareSlide;
